import { Check, Pencil, Trash, Clipboard } from "lucide-react"
import React from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { Button, Card, CardBody, Table } from "reactstrap"

import { usePermissions } from "hooks"
import { handleStopPropagation } from "components/Common/Utils"
import Paginations from "components/Common/Pagination"

const TableComponent = ({
  loading,
  data = [],
  onMarkAttendanceClick,
  onDeleteClick,
  itemIdToDelete,
  currentPage,
  totalPages,
  totalCount,
  onPageChange,
  isLoading,
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { permissions, showAll } = usePermissions("practical_training")

  const headers = [
    "S. No.",
    "Name",
    "Site",
    "Station",
    "Managed By",
    "Participants Count",
    "Attendance Count",
    "Start Date",
    "Start Time",
    "Duration",
    "Action",
  ]

  if (loading && data.length === 0) {
    return <p>{t("No data found")}</p>
  }

  return (
    <>
      <Card className="user_personal_info theme_card overflow-x-auto">
        <CardBody>
          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="table-light full_th">
                <tr>
                  {headers.map((header, index) => (
                    <th key={index}>{t(header)}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={index}>
                    <th scope="row">{index + 1}</th>
                    <td>
                      <p
                        className="text-decoration-underline cursor-pointer"
                        onClick={() => {
                          if (
                            showAll ||
                            permissions.includes("can_view_participants_lists")
                          ) {
                            navigate(
                              `/practical-training/participants?uuid=${item.uuid}`,
                              {
                                state: {
                                  end_date: item?.end_date,
                                  end_time: item?.end_time,
                                },
                              }
                            )
                          }
                        }}
                      >
                        {item.name}
                      </p>
                    </td>
                    <td>{item.site}</td>
                    <td>{item.station}</td>
                    <td>{item.managed_by}</td>
                    <td>{item.participants_count}</td>
                    <td>{item.attendance_count}</td>
                    <td>
                      <p className="ltr fit_content">{item.start_date}</p>
                    </td>
                    <td>
                      <p className="ltr fit_content">{item.start_time}</p>
                    </td>
                    <td>
                      {item.duration}{" "}
                      {item.duration == 1
                        ? t("Hour")
                        : item.duration > 1
                        ? t("Hours")
                        : ""}
                    </td>
                    <td onClick={handleStopPropagation}>
                      <div className="d-flex gap-2 action_buttons">
                        {(showAll || permissions.includes("can_edit")) && (
                          <Button
                            color="secondary"
                            onClick={() =>
                              navigate(
                                `/practical-training/update?id=${item.uuid}`
                              )
                            }
                            title={t("Update")}
                          >
                            <Pencil />
                          </Button>
                        )}
                        {(showAll || permissions.includes("can_create")) && (
                          <Button
                            color="secondary"
                            onClick={() => {
                              navigate(
                                `/practical-training/create?id=${item?.uuid}`
                              )
                            }}
                            disabled={
                              isLoading && item?.uuid === itemIdToDelete
                            }
                            title={t("Clone")}
                          >
                            <Clipboard />
                          </Button>
                        )}
                        {(showAll ||
                          permissions.includes("can_mark_attendance")) && (
                          <Button
                            color="primary"
                            onClick={() => onMarkAttendanceClick(item)}
                            title={t("Mark Attendance")}
                          >
                            <Check />
                          </Button>
                        )}
                        {(showAll || permissions.includes("can_delete")) && (
                          <Button
                            color="danger"
                            onClick={() => onDeleteClick(item)}
                            disabled={loading && item.uuid === itemIdToDelete}
                            title={t("Delete")}
                          >
                            <Trash />
                          </Button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
      {!loading && data.length > 0 && (
        <Paginations
          currentPage={currentPage}
          totalPages={totalPages}
          totalCount={totalCount}
          onPageChange={onPageChange}
        />
      )}
    </>
  )
}

export default TableComponent
